import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { catchError, map } from 'rxjs/operators';
import * as moment from 'moment-timezone';

import { APP_SETTINGS } from '../../shared/models/backofficeConfiguration';
import { ExecuteService } from '../../shared/services/executeService.service';
import { ErrorHandlerService } from '../../shared/services/errorHandler.service';
import { UserPaymentTransactionSite } from '../model/UserPaymentTransactionSite';

@Injectable()
export class PaymentTransactionsService {
  private usersApiURL = APP_SETTINGS.UsersApiUrl;
  private userPayApiURL = APP_SETTINGS.UserPayApiUrl;

  constructor(
    private executeService: ExecuteService,
    private errorHandler: ErrorHandlerService) {
  }

  public GetPaymentTransactionsByUserId(userId: string): Observable<UserPaymentTransactionSite[]> {
    const url: string = this.usersApiURL + `${userId}/paymentTransactions`;

    return this.executeService.ExecuteWithToken('get', url)
      .pipe(
        map(response => this.mapModels(response)),
        catchError(this.errorHandler.handleError('PaymentsService_GetPaymentTransactionsByUserId userId', [], true))
      );
  }

  public GetPaymentTransactionsByUserIdFromPay(userId: string): Observable<UserPaymentTransactionSite[]> {
    const url: string = `${this.userPayApiURL}/api/v1/PaymentTransaction/${userId}`;

    return this.executeService.ExecuteWithToken('get', url)
      .pipe(
        map(response => this.mapModels(response)),
        catchError(this.errorHandler.handleError('PaymentsService_GetPaymentTransactionsByUserId userId', [], true))
      );
  }

  mapModels(transactions: any[]): UserPaymentTransactionSite[] {
    let response: UserPaymentTransactionSite[] = [];
    if (transactions !== null) {
      response = transactions.map(t => ({
        id: t.id,
        subscription: {
          id: t.subscription.id,
          name: t.subscription.name,
          months: t.subscription.months,
          productType: t.subscription.productType ? t.subscription.productType.replace(/([a-z])([A-Z])/g, '$1 $2') : null
        },
        email: t.email,
        dateUtc: moment(t.dateUtc),
        type: t.type,
        formattedType: t.type ? t.type.replace(/([a-z])([A-Z])/g, '$1 $2') : null,
        paymentPlatform: t.paymentPlatform,
        details: t.details,
        amount: t.amount,
        platformSubId: t.platformSubId
      }));
    }
    return response;
  }
}



// WEBPACK FOOTER //
// ./src/app/users/services/paymentTransactions.service.ts